module.exports = __webpack_public_path__ + "img/head.8ace43b1.png";